module.exports = global["pdfMake"] = require("-!d:\\pdfmake\\pdfmake-master\\node_modules\\babel-loader\\lib\\index.js??ref--4!.\\pdfMake.js");